import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, Inject, InjectionToken, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fromEvent } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { LifecycleManaging } from '../../../../abstract/lifecycle-managing';
import { HasUnsavedData, UnsavedDataGuard } from '../../guards';

export const UNSAVED_DATA_TOKEN = new InjectionToken<HasUnsavedData>('UnsavedDataToken');

@Directive({
// tslint:disable-next-line: directive-selector
  selector: 'form',
})
export class UnsavedDataDirective extends LifecycleManaging implements OnInit, OnDestroy {

  @Input() disableUnsaved: boolean;

  constructor(@Inject(UNSAVED_DATA_TOKEN) @Optional() private unsavedData: HasUnsavedData, 
              private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    if (coerceBooleanProperty(this.disableUnsaved)) {
      return;
    }

    if (this.areGuardsInvalid()) {
      return;
    }

    this.setUpEventListener();
  }

  setUpEventListener() {
    fromEvent(window, 'beforeunload')
      .pipe(
        filter(() => this.unsavedData.hasUnsavedData()),
        tap(event => {
          event.preventDefault();                                             // Specs
          const confirmationMessage = '';
          ((event || window.event) as any).returnValue = confirmationMessage; // Gecko + IE
          return confirmationMessage;                                         // Webkit, Safari, Chrome
        }),
        takeUntil(this.destroySubject)
      ).subscribe();
  }

  areGuardsInvalid(): boolean {

    if (!(this.route.routeConfig
      && this.route.routeConfig.canDeactivate
      && this.route.routeConfig.canDeactivate.find(val => val === UnsavedDataGuard))) {
      console.warn('Component has form but doesn\'t have UnsavedDataGuard');
    }

    if (!this.unsavedData) {
      console.warn('Component has form but doesn\'t have UNSAVED_DATA_TOKEN assigned');
      return true;
    }

    return false;
  }
}
